import richText from "utilities/richText"

export default function ContentAndCardSection({ blok }) {
  return (
    <section className="bg-highlight-tint bg-cover px-5 py-10 overflow-x-hidden">
      <div className="mx-auto max-w-screen-xl">
        <div className="flex flex-col md:flex-row md:justify-between md:gap-8">
          <div className="md:basis-1/3 md:flex md:flex-col">
            <div className="prose-headings:text-primary prose-headings:mb-4 pb-7">{richText(blok.main_content)}</div>
          </div>
          <div className="md:basis-2/3 flex flex-col gap-4">
            {blok.cards.map((card) => (
              <div
                key={card._uid}
                className="bg-white shadow-[2px_6px_6px_0px_rgba(18,36,72,0.10)] p-7 prose-headings:pb-4 prose-h3:text-m2 prose-headings:text-primary"
              >
                {richText(card.content)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
